import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Flex, Text } from '@radix-ui/themes';
import { CommonTooltip } from 'components/common/tooltip';
import { t } from 'i18next';
import { IInputLabel } from 'interfaces/forms/_base';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const CommonInputLabel = (props: IInputLabel) => {
  if (!props.label) {
    return null;
  }

  const label = [props.label, props.labelOptional ? '(optional)' : '']
    .filter((s) => s)
    .map((s) => t(s).toString())
    .join(' ');

  return (
    <Flex gap="1" align="center" justify={props.labelJustify ?? 'between'}>
      <Flex gap={RADIX.FLEX.GAP.XS} align="center">
        <Text color={props.labelColor} truncate>
          {/* &nbsp; required here to reserve the vertical space if label is a whitespace char */}
          {label}&nbsp;
        </Text>
        {props.labelIcon && <Flex align="center">{props.labelIcon}</Flex>}
      </Flex>

      {props.iconTooltip && (
        <Flex pt="1">
          <CommonTooltip
            text_md={props.iconTooltip}
            trigger={<InfoCircledIcon />}
          />
        </Flex>
      )}
    </Flex>
  );
};
